import {createReducer, on} from '@ngrx/store';
import {INITIAL_LOAD_STATUS_SUBSTATE, LoadStatusSubstate} from '@aviary/store/store.types';
import {FAILED, LOADED, LOADING} from '@aviary/store/common/common.types';
import {BalanceActions} from './balance.actions';
import {FALLBACK_SQUARE_APP_DETAILS} from './balance.fallback';
import {PatronBalanceTransaction, SquareAppDetails} from './balance.types';
import {PatronActions} from '@store/patron/patron.actions';

export interface BalanceState {
  balanceTransactions: LoadStatusSubstate & {
    data: PatronBalanceTransaction[];
    includeAllTransactions: boolean;
  };
  squareAppDetails: LoadStatusSubstate & {
    data: SquareAppDetails
  };
  dependentBalanceTransactions: LoadStatusSubstate & {
    data: PatronBalanceTransaction[];
    includeAllTransactions: boolean;
  };
}

export const INITIAL_BALANCE_STATE: BalanceState = {
  balanceTransactions: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
    includeAllTransactions: false
  },
  squareAppDetails: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: FALLBACK_SQUARE_APP_DETAILS,
  },
  dependentBalanceTransactions: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    data: [],
    includeAllTransactions: false
  },
};

export const balanceState = createReducer(
  INITIAL_BALANCE_STATE,

  on(BalanceActions.loadBalanceTransactions, state => ({
    ...state,
    balanceTransactions: {
      ...state.balanceTransactions,
      loadStatus: LOADING
    }
  })),
  on(BalanceActions.loadBalanceTransactionsSuccess, (state, {listData: {data}}) => ({
    ...state,
    balanceTransactions: {
      ...state.balanceTransactions,
      loadStatus: LOADED,
      data
    }
  })),
  on(BalanceActions.loadBalanceTransactionsFailure, state => ({
    ...state,
    balanceTransactions: {
      ...INITIAL_BALANCE_STATE.balanceTransactions,
      loadStatus: FAILED
    }
  })),
  on(BalanceActions.toggleIncludeAllBalanceTransactions, state => ({
    ...state,
    balanceTransactions: {
      ...state.balanceTransactions,
      includeAllTransactions: !state.balanceTransactions.includeAllTransactions
    }
  })),
  on(BalanceActions.loadSquareAppDetails, state => ({
    ...state,
    squareAppDetails: {
      ...state.squareAppDetails,
      loadStatus: LOADING
    }
  })),
  on(BalanceActions.loadSquareAppDetailsSuccess, (state, {squareAppDetails}) => ({
    ...state,
    squareAppDetails: {
      ...state.squareAppDetails,
      loadStatus: LOADED,
      data: squareAppDetails,
    }
  })),
  on(BalanceActions.loadSquareAppDetailsFailure, state => ({
    ...state,
    squareAppDetails: {
      ...INITIAL_BALANCE_STATE.squareAppDetails,
      loadStatus: FAILED
    }
  })),

  on(PatronActions.loadDependentBalanceTransactions, state => ({
    ...state,
    dependentBalanceTransactions: {
      ...state.dependentBalanceTransactions,
      loadStatus: LOADING
    }
  })),
  on(PatronActions.loadDependentBalanceTransactionsSuccess, (state, {listData: {data}}) => ({
    ...state,
    dependentBalanceTransactions: {
      ...state.dependentBalanceTransactions,
      loadStatus: LOADED,
      data
    }
  })),
  on(PatronActions.loadDependentBalanceTransactionsFailure, state => ({
    ...state,
    dependentBalanceTransactions: {
      ...INITIAL_BALANCE_STATE.dependentBalanceTransactions,
      loadStatus: FAILED
    }
  })),
  on(PatronActions.toggleIncludeAllDependentBalanceTransactions, state => ({
    ...state,
    dependentBalanceTransactions: {
      ...state.dependentBalanceTransactions,
      includeAllTransactions: !state.dependentBalanceTransactions.includeAllTransactions
    }
  })),
);
